import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import jump from "jump.js";
import Icon from "@mdi/react";
import Text from "../../components/typography/Text";
import Button from "../../components/buttons/Button";
import useMedia from "../../hooks/useMedia";
import { mdiArrowDown } from "@mdi/js";

const Hero = ({ title, description, first_button, second_button, history }) => {
  const media = useMedia();

  const animateArrow = () => {
    const node = document.querySelector(".animated_arrow");
    node.classList.add(`animate__animated`, "animate__fadeInDown");

    function handleAnimationEnd(event) {
      console.log("Animation ended");
      event.stopPropagation();
      node.classList.remove(`animate__animated`, "animate__fadeInDown");
    }

    node.addEventListener("animationend", handleAnimationEnd, { once: true });
  };

  useEffect(() => {
    const interval = setInterval(animateArrow, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="oHomeHero">
      <div className="oHomeHero_wrapper">
        <div className="oHomeHero_content">
          <h1>{title}</h1>
          <Text big>{description}</Text>
          <div className="oHomeHero_buttons">
            {media !== "mobile" && (
              <>
                {first_button && (
                  <Button
                    big
                    rounded
                    onClick={() => history.push(first_button.url)}
                  >
                    {first_button.title}
                  </Button>
                )}
                {second_button && (
                  <Button
                    big
                    rounded
                    outlined
                    orange
                    onClick={() => jump(second_button.url)}
                    second
                  >
                    <div>{second_button.title}</div>
                    <Icon
                      path={mdiArrowDown}
                      size={0.75}
                      className={`button_icon animated_arrow`}
                    />
                  </Button>
                )}
              </>
            )}
            {media === "mobile" && (
              <>
                <Button big rounded onClick={() => history.push(first_button.url)}>
                  {first_button.title}
                </Button>
                <Button
                  big
                  rounded
                  outlined
                  orange
                  onClick={() => jump(second_button.url)}
                  second
                >
                  <div>{second_button.title}</div>
                  <Icon
                    path={mdiArrowDown}
                    size={0.75}
                    className={`button_icon animated_arrow`}
                  />
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Hero);
